/**
 * App-wide constants and env helpers.
 * Centralizes Vite env (VITE_*) so the rest of the app imports from config.
 */
const env = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {}

/** API base URL (no trailing slash). Default: backend-dev. */
export const API_BASE_URL = env.VITE_BASE_URL || 'https://backend-dev.tubatoolbox.com'

/** Base URL for media assets. Empty string if not set. */
export const MEDIA_BASE_URL = env.VITE_MEDIA_BASE_URL || ''

/** Whether the app is in development mode (Vite). */
export const isDev = env.DEV === true

/** Whether to show the onboarding wizard. */
export const showOnboardingWizard = (env.VITE_SHOW_ONBOARDING_WIZARD || '').toLowerCase() === 'true'
